import { sqliteTable, text, integer, uniqueIndex, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// ai_tenant_providers — Tenant-scoped LLM provider credentials/settings
// ============================================================================
export const aiTenantProviders = sqliteTable(
  "ai_tenant_providers",
  {
    id: text("id").primaryKey(), // ULID
    provider: text("provider").notNull(),
    apiKey: text("api_key"),
    accountId: text("account_id"),
    isEnabled: integer("is_enabled").notNull().default(0),
    createdAt: text("created_at").notNull(),
    createdBy: text("created_by"),
    updatedAt: text("updated_at").notNull(),
    updatedBy: text("updated_by"),
    lastTestStatus: text("last_test_status"),
    lastTestedAt: text("last_tested_at"),
  },
  (table) => [
    uniqueIndex("idx_ai_tenant_providers_provider").on(table.provider),
    index("idx_ai_tenant_providers_enabled").on(table.isEnabled),
  ],
);

export type AiTenantProvider = typeof aiTenantProviders.$inferSelect;
export type NewAiTenantProvider = typeof aiTenantProviders.$inferInsert;
